<template>
  <div class="black-back"> 
    <div v-if="pageloading" style="z-index: 1000;background:#000; opacity: 0.5;position: fixed ; top:0;bottom:0;right:0;left:0">
 <van-loading size="24px"  color="#fff" style="margin-top:100px;z-index: 1001" vertical>加载中...</van-loading>
 </div>

    <div class="score-head">
      <div class="score-logo">
        <div class="score-logo-box"> 
          <img src="../../../assets/images/score/logo2.png" alt="">
        </div>
      </div>
      <div class="score-title">{{ row.saiqu_name }} {{ row.title }}</div>
      <div class="score-title-child">{{ row.subject.subject_name }}</div>
      <div class="score-title-child" >{{ row.subject.mingcheng }}</div>
      <!-- <div class="score-title-child" @click="peopleShow = true">{{ row.subject.mingcheng }}</div> -->
    </div>
    <div class="score-content" style="margin-top:-10px;padding-top:0;padding-bottom:0">

<video
  v-if="row.subject.video"
  width="100%"
  height="180px"
 :src="row.subject.video"   controls  ></video> 
  <van-notice-bar  v-else style="z-index: 10000; width:100%" text="视频未上传"/>

    </div>

    <div class="score-content">
      <div class="score-content-left" style="margin-bottom:10px">
        <div class="score-value-box">
          <div class="score-value-text flex-between">
            <div class="flex-start">
              <div class="score-value-label"></div>
              <div class="score-value-li">{{'A组裁判' + '-' + (row.caipan.index + 1) + '-' + row.caipan.name}}分值</div>
            </div>
            <div class="flex-start" style="font-size: 18px;cursor: pointer" 
            v-if="row.subject.video"
                        v-clipboard:copy="row.subject.video"
                        v-clipboard:success="onCopy"
                        > 
              <van-icon name="edit" /> 
              <div style="margin-left: 2px">复制网址</div>
            </div>
            <div class="flex-start" style="font-size: 18px;cursor: pointer" @click="onRefresh">
              <van-icon name="replay"/>  
              <div style="margin-left: 2px">刷新</div>
            </div>
          </div>
          <div class="score-value-content flex-center">{{ formData.score > 0 ? formData.score : '--' }}
<van-icon name="play" v-if="scoreStatus=='pen'" style="transform: rotate(90deg);"  color="#0dac0d" />  
<van-icon v-if="scoreStatus=='add'" name="play"  style="transform: rotate(-90deg);"  color="#ff0000" />  
          </div>
          <div class="score-comment-box" v-if="false">
            <div class="score-comment-head flex-between">
              <div class="score-comment-head-left flex-start">
                <div class="score-value-label"></div>
                <div class="score-value-li">评语</div>
              </div>
              <div class="score-comment-head-right" @click="onComment">
<!--                <img src="https://static.dierqudao.com/images/cca/comment-edit.png" alt="">-->
                <img src="../../../assets/images/score/comment-edit.png" alt="">
              </div>
            </div>
            <div class="score-comment-text">
              <!-- {{ formData.content }} -->
              <!-- {{commentResult}} --> 
              <van-tag style="margin:0 10px 10px 0" @click="commentClose(cindex)" closeable @close="commentClose(cindex)"  :key="cindex" v-for="cvalue,cindex in commentResult">{{cvalue.name}}</van-tag>
              
            </div>
          </div>
          <div class="score-caipan-box score-caipan-online" v-if="false">
          <div class="score-caipan-value flex-between">
            <div class="score-caipan-left flex-start">
              <div class="caipan-button" style="padding: 5px 10px 5px 0;" @click="toLoginOutAuto">退出</div>
              <div class="caipan-name"> {{
                  row.caipan.jgroup == 1 ? 'B组裁判' + '-' + (row.caipan.index + 1) + '-' + row.caipan.name :
                      'A组裁判' + '-' + (row.caipan.index + 1) + '-' + row.caipan.name
                }}
              </div>
            </div>
            <!--            <div class="score-caipan-right">{ reconnectShow ? '重新联网' : '网络正常' }}</div>-->
            <div class="score-caipan-right">网络正常</div>
          </div>
        </div>
        </div>
        <!--        <div @click="toReLogin" :class="reconnectShow ? 'score-caipan-box score-caipan-offline' : 'score-caipan-box score-caipan-online' ">-->
        
      </div>
      <div class="score-content-right flex-start">
        <div class="key-left">
          <div class="key-li" @click="onKey(1)">1</div>
          <div class="key-li" @click="onKey(2)">2</div>
          <div class="key-li" @click="onKey(3)">3</div>
          <div class="key-li" @click="onKey(4)">4</div>
          <div class="key-li" @click="onKey(5)">5</div>
          <div class="key-li" @click="onKey(6)">6</div>
          <div class="key-li" @click="onKey(7)">7</div>
          <div class="key-li" @click="onKey(8)">8</div>
          <div class="key-li" @click="onKey(9)">9</div>
          <div class="key-li-full" @click="onKey(0)">0</div>
          <div class="key-li" @click="onKey('.')">.</div>
        </div>
        <div class="key-right">
          <div class="key-delete flex-center" @click="onKey('delete')">
<!--            <img src="https://static.dierqudao.com/images/cca/score-delete.png" alt="">-->
            <img src="../../../assets/images/score/score-delete.png" alt="">
          </div>
          <div class="key-button flex-center" style="background: #1989FA;color: #fff;" @click="onSubmit"
               v-if="row.caipan.jgroup === row.subject.jgroup && !scoreCurrent || scoreStatus">提交
          </div>
          <div class="key-button flex-center" style="background: #44D7B6;color: #fff;cursor:not-allowed " v-else>完成
          </div>
        </div>
      </div>

      

    </div>



    <div class="savebtn">

        <van-button 
                size="normal" round @click="goPre()">上一队</van-button>
 
        <van-button 
                size="normal" round @click="showList()">全部队伍{{current_index+1}}/{{list.length}}</van-button>
 

        <van-button 
                size="normal" round @click="goNext()">下一队</van-button>
 
    </div>

    <div style="color: #fff" v-if="false">
      <div>that.formData: || {{ formData }}</div>
      <div>row.caipan: || {{ row.caipan }}</div>
      <div>row.subject: || {{ row.subject }}</div>
      <div>scoreStatus: || {{ scoreStatus }}</div>
      <div>dataAll: || {{ dataAll }}</div>
    </div>
    <!-- <van-dialog v-model="commentShow" title="添加评语">
      <van-field
          v-model="formData.content"
          clearable
          :closeOnClickOverlay="true"
          :autofocus="true"
          label="评语"
          @input="onCommentChange"
          placeholder="请输入评语"
      />
    </van-dialog> -->
    <van-popup v-model="peopleShow">
      <div class="people">
        <div class="people-title">运动员</div>
        <div class="people-content">{{ row.subject.yundongyuans }}</div>
      </div>
    </van-popup>

    <van-popup v-model="listShow" style="width:90%; height:80%;">
      <div style="width:100%; height:100%; overflow:-y scroll;">
        <van-cell-group>
          <van-cell
            :icon="iindex==current_index?'success':''"
            v-for="(item,iindex) in list"
            center
            is-link
            @click="onSelect(item,iindex)"
            :label="item.mingcheng"
            :key="item.id"
          >
          <template slot="title">

            <!-- :title="(iindex+1)+'# '+item.subject_name" -->
            <div class="flex-align">
              <span class="font-size3 bold "
              :class="item['score'+formData.score_index]>0?'ok':''"
              >{{iindex+1}}# {{item.subject_name}}</span>
                
            </div>
          </template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>

 
  </div>

</template>
<style scoped>
.comment-selector{
  width: 100%;
  height: 90%;
  background: #fff;
}
.black-back {
  background: rgb(0, 0, 0);
  min-height: 100vh;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.key-li:active, .key-li-full:active, .key-delete:active {
  background: #ebedf0;
}

.score-caipan-online {
  background: #1989FA;
}

.score-caipan-offline {
  background: #FA6400;
}

.people {
  padding: 0.2rem 0.3rem;
  border-radius: 0.2rem;
}

.people-title {
  padding: 0.2rem 0;
  font-size: 16px;
  font-weight: 700;
}

.people-content {
  padding: 0.2rem 0;
}

@media (max-width: 768px) {
  .score-value-text {
    padding-top: 0.1562rem;
    padding-left: 0.0937rem;
    padding-right: 0.0937rem;
  }

  .score-value-label {
    width: 8px;
    height: 0.25rem;
    background: #1D85E2;
    border-radius: 5px;
    margin-right: 10px;
  }

  .score-value-li {
    font-size: 0.28rem;
    font-weight: 500;
    color: #000000;
  }

  .score-value-content {
    font-size: .88rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #000000;
    margin-top: -15px;
    /* margin: 0.1rem 0 .1rem; */
  }

  .score-comment-box {
    margin: 0 10px 10px;
    background: #D3EBFF;
    overflow-y: hidden;
    height: 1.2rem;
    border-radius: .1562rem;

  }

  .score-comment-head {
    padding: 10px 20px;
  }

  .score-comment-head-right img {
    width: .1875rem;
  }

  .score-comment-text {
    padding: 0 20px;
    font-size: .2rem;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .key-right {
    width: 120%;
  }

  .key-delete, .key-button {
    width: 100%;
    height: 1.9rem;
    background: #fff;
    border-radius: 0.0781rem;
  }

  .key-button {
    font-size: .5rem;
  }

  .key-delete img {
    width: 0.5rem;
  }

  .key-button {
    margin-top: .05078rem;
  }

  .key-left {
    display: flex;
    flex-wrap: wrap;
    /*width: 3.0816rem;*/
  }

  .key-li {
    width: 1.5rem;
    height: 0.9rem;
    background: #fff;
    border-radius: 0.1rem;
    margin: 0 .1rem .05rem 0;
    font-size: 0.5rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .key-li-full {
    width: 3.1rem;
    height: 0.9rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .1rem .05rem 0;
    font-size: 0.5rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .score-content {
    padding: 0.1835rem;
  }

  .score-content-right {
    /*width: 4.1367rem;*/
    background: #F2F3F5;
    border-radius: 0.15625rem;
    height: 4rem;
    padding: 0 0.0859rem;
  }

  .score-value-box {
    background: #fff;
    /* height: 2rem; */
    border-radius: 0.15625rem;
    box-shadow: 0px 2px 20px 0px rgba(74, 144, 226, 0.1);
  }

  .score-caipan-box {
    height: 0.5rem;
    border-radius: 0.5rem;
    color: #fff;
    font-weight: 500;
    font-size: .18rem;
    margin: .15rem 0;
  }

  .score-caipan-value {
    margin: 0 32px 0 22px;
    height: 100%;
  }

  .score-head {
    /*background: url('https://static.dierqudao.com/images/cca/score-bg.png') no-repeat;*/
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% 1.6rem;
    height: 1.6rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }

  .score-logo {
    position: absolute;
    top: .15rem;
    left: .195rem;
  }

  .score-logo-box {
    padding: 2px;
    /* background: rgb(255, 255, 255); */
    border-radius: 100%;
  }

  .score-logo-box img {
    min-width: 0.5rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
    border:1px solid #fff
  }

  .score-title {
    font-size: 0.2rem;
    padding: .2rem 0;
  }

  .score-title-child {
    font-size: .18rem;
    /*padding: 19px 0;*/
  }
}

@media screen and  (min-width: 768px) and (max-width: 1199px) {
  .score-value-text {
    padding-top: 0.1562rem;
    padding-left: 0.0937rem;
    padding-right: 0.0937rem;
  }

  .score-value-label {
    width: 8px;
    height: 0.1562rem;
    background: #1D85E2;
    border-radius: 5px;
    margin-right: 10px;
  }

  .score-value-li {
    font-size: 0.1875rem;
    font-weight: 500;
    color: #000000;
  }

  .score-value-content {
    font-size: .5rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #000000;
    /* margin: 0.2656rem 0 .1562rem; */
  }

  .score-comment-box {
    margin: 0 10px 10px;
    background: #D3EBFF;
    height: .7812rem;
    border-radius: .1562rem;

  }

  .score-comment-head {
    padding: 10px 20px;
  }

  .score-comment-head-right img {
    width: .1875rem;
  }

  .score-comment-text {
    padding: 0 20px;
    font-size: .1132rem;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .key-right {
    width: 85%;
  }

  .key-delete, .key-button {
    width: 100%;
    height: 1.2537rem;
    background: #fff;
    border-radius: 0.0781rem;
  }

  .key-button {
    font-size: .16rem;
  }

  .key-delete img {
    width: 0.3482rem;
  }

  .key-button {
    margin-top: .05078rem;
  }

  .key-left {
    display: flex;
    flex-wrap: wrap;
    /*width: 3.0816rem;*/
  }

  .key-li {
    width: 0.9257rem;
    height: 0.6015rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .10156rem .05078rem 0;
    font-size: 0.28rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .key-li-full {
    width: 1.9529rem;
    height: 0.6015rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .10156rem .05078rem 0;
    font-size: 0.28rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .score-content {
    padding: 0.1835rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .score-content-right {
    width: 4.1367rem;
    background: #F2F3F5;
    border-radius: 0.15625rem;
    height: 3rem;
    padding: 0 0.0859rem;
  }

  .score-value-box {
    background: #fff;
    width: 2.9179rem;
    height: 2.5664rem;
    border-radius: 0.15625rem;
    box-shadow: 0px 2px 20px 0px rgba(74, 144, 226, 0.1);
    margin: 0 .07rem .07rem 0;
  }

  .score-caipan-box {
    width: 2.9179rem;
    height: 0.375rem;
    border-radius: 0.375rem;
    /*padding: 0 32px 0 44px;*/
    color: #fff;
    font-weight: 500;
    font-size: .1093rem;
  }

  .score-caipan-value {
    margin: 0 32px 0 44px;
    height: 100%;

  }

  .score-head {
    /*background: url('https://static.dierqudao.com/images/cca/score-bg.png') no-repeat;*/
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% 1rem;
    height: 1rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }

  .score-logo {
    position: absolute;
    top: .1rem;
    left: .195rem;
  }

  .score-logo-box {
    padding: 2px;
    background: rgb(255, 255, 255);
    border-radius: 100%;
  }

  .score-logo-box img {
    width: 0.4rem;
    min-width: 0.4rem;
    height: 0.4rem;
    border-radius: 100%;
  }

  .score-title {
    font-size: 0.2rem;
    padding: .1rem 0;
  }

  .score-title-child {
    font-size: .15rem;
    /*padding: 19px 0;*/
  }
}

@media screen and (min-width: 1200px) {
  .score-value-text {
    padding-top: 0.1562rem;
    padding-left: 0.0937rem;
    padding-right: 0.0937rem;
  }

  .score-value-label {
    width: 8px;
    height: 0.1562rem;
    background: #1D85E2;
    border-radius: 5px;
    margin-right: 10px;
  }

  .score-value-li {
    font-size: 0.1875rem;
    font-weight: 500;
    color: #000000;
  }

  .score-value-content {
    font-size: .7812rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #000000;
    margin: 0.2656rem 0 .1562rem;
  }

  .score-comment-box {
    margin: 0 10px 10px;
    background: #D3EBFF;
    height: .7812rem;
    border-radius: .1562rem;

  }

  .score-comment-head {
    padding: 10px 20px;
  }

  .score-comment-head-right img {
    width: .1875rem;
  }

  .score-comment-text {
    padding: 0 20px;
    font-size: .1132rem;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .key-right {
    /*width: 0.9257rem;*/
    width: 85%;
  }

  .key-delete, .key-button {
    width: 100%;
    height: 1.2537rem;
    background: #fff;
    border-radius: 0.0781rem;
  }

  .key-button {
    font-size: .16rem;
  }

  .key-delete img {
    width: 0.3482rem;
  }

  .key-button {
    margin-top: .05078rem;
  }

  .key-left {
    display: flex;
    flex-wrap: wrap;
    /*width: 3.0816rem;*/
  }

  .key-li {
    width: 0.9257rem;
    height: 0.6015rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .10156rem .05078rem 0;
    font-size: 0.28rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .key-li-full {
    width: 1.9529rem;
    height: 0.6015rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .10156rem .05078rem 0;
    font-size: 0.28rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .score-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0.1835rem;
  }

  .score-content-right {
    width: 4.1367rem;
    background: #F2F3F5;
    border-radius: 0.15625rem;
    height: 3rem;
    padding: 0 0.0859rem;
  }

  .score-value-box {
    background: #fff;
    width: 2.9179rem;
    height: 2.5664rem;
    border-radius: 0.15625rem;
    box-shadow: 0px 2px 20px 0px rgba(74, 144, 226, 0.1);
    margin: 0 .07rem .07rem 0;
  }

  .score-caipan-box {
    width: 2.9179rem;
    height: 0.375rem;
    border-radius: 0.375rem;
    color: #fff;
    font-weight: 500;
    font-size: .1093rem;
  }

  .score-caipan-value {
    margin: 0 32px 0 44px;
    height: 100%;

  }

  .score-head {
    /*background: url('https://static.dierqudao.com/images/cca/score-bg.png') no-repeat;*/
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% .8rem;
    height: .8rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }

  .score-logo {
    position: absolute;
    top: .078rem;
    left: .195rem;
  }

  .score-logo-box {
    padding: 2px;
    background: rgb(255, 255, 255);
    border-radius: 100%;
  }

  .score-logo-box img {
    width: 0.234rem;
    min-width: 0.234rem;
    height: 0.234rem;
    border-radius: 100%;
  }

  .score-title {
    font-size: 0.15625rem;
    padding: .074rem 0;
  }

  .score-title-child {
    font-size: .117rem;
    /*padding: 19px 0;*/
  }

  .van-tag{
    font-size: 16px;
  }

}

.ok{color: rgb(2, 110, 2); font-weight: bold;}


  .savebtn{
    display: flex;
    justify-content:space-between;
    padding:0  0.1835rem 0  0.1835rem;
  }

</style>
<script>
import Vue from 'vue';
import NumKeypad from '@/components/NumKeypad.vue';
import {
  Cell,
  Icon,
  Field,
  Tag,
  Popup,
  Stepper,
  Toast,
  Dialog,
  Button,  
  Picker,
} from 'vant';

export default {
  name: 'CommonScore',
  components: {

    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [Stepper.name]: Stepper,
    [Picker.name]: Picker,
    NumKeypad
  },
  data: function () {
    return {
      commentShow: false,
      saveLoading: false,
      pageloading:false,
      isLoading: false,
      listShow:false,
      showCommentSubjectPicker:false,
      commentResult:[],
      commentSubject:'',
      commentOptionsTree:[],
      commentOptions:[
        // {
        //   name:'选项1',
        //   checked:false,
        // }, 
      ],
      peopleShow: false,
      current_index:0,
      row: { 
        caipan: {jgroup: 0},
        subject: {subject_name: '', jgroup: 0,video:''}
      },
      list:[],
      commentSubjectcolumns:[
        // '项目1','项目2','项目3'
      ],
      subSubjectTabs:[
        // '花球','托举','爵士'
      ],
      selectTopIndex:0,
      selectSubIndex:0,
      subSubjectValue:0,
      selectComments:'',
      id: 0,
      start_id: 0, //场次id
      heartTime: 0, //超过14s 显示重连
      reconnectShow: false,
      scoreStatus: '',
      commentContent: '',
      scoreCurrent: 0,
      commentList: [],
      formData: {
        id: 0,
        score_index: 0,
        start_id:0,
        score: '',
        content: '',
      },
      dataAll: [],

      timer: null
    }
  },
  filters: {},
  mounted() {
    let that = this;
    // that.init()
    document.title="打分"
    // 换成轮询
    that.formData.start_id = that.$route.query.id || 86
    that.fetch(); 
    that.getList();

    // that.getCommentList();
  },
  watch: {}, 
  destroyed() {
    // 销毁监听
    // this.clearAll()
    // this.socket.close()
  
    localStorage.removeItem('_score')
    localStorage.removeItem('_content')

    // 裁判注销
    // that.onLoginOut()
  },
  methods: { 
    onRefresh(){
      this.getList()
      this.fetch()
    },
    getList(){
      let that = this;
      that.$api.post('/api/dshequscore/scoreList', {
        start_id:that.formData.start_id
      },(res) =>{
        that.list =  res.data.list
      },(res) => {
        Toast(res.msg)
      })
    },
    fetch() {
      let that = this;
      that.pageloading = true
      that.$api.post('/api/dshequscore/subjectDetail', {
        num: localStorage.getItem('_id_num'),
        current_index: that.current_index
      }, (res) => {
        let row = that.row = res.data.row;
        that.isLoading = false;
        that.pageloading = false;

        let score = that.scoreCurrent = parseFloat(row.subject['score' + (row.caipan.index + 1)])
        let content = that.commentContent = row.subject['comment' + (row.caipan.index + 1)]

        if(row.subject['score_fix_' + (row.caipan.index + 1)]){
          that.scoreStatus = row.subject['score_fix_' + (row.caipan.index + 1)]
        }

        //场次信息 场次的id 当前裁判的index ，num

        that.formData.score = score ? score : ''
        that.formData.content = content ? content : ''
        that.formData.score_index = row.caipan.index + 1
        that.formData.id = row.subject.id

        that.start_id = res.data.row.id 

        // 存在 row.subject.jgroup不存在的情况
        row.subject.jgroup = row.subject.jgroup ? row.subject.jgroup : 0

        if (row.caipan.jgroup != row.subject.jgroup) {
          Toast('不属于当前组别裁判')
        }

        // 发送心跳超过 40s 显示重连按钮
        that.heartReconnectTimer = setInterval(function () {
          that.heartTime += 1
          // console.log('that.heartTime', that.heartTime)
          if (that.heartTime > 40) {
            that.reconnectShow = true
          }
        }, 1000)
      }, (res) => {
        that.pageloading = false
        Toast(res.msg)
      }, 2)
    },
    showList(){
      this.listShow=true
    },
    goPre(){
      if(this.current_index<=0){
        Toast('已经是第一只队伍了')
        return
      }
      this.current_index--
      this.onRefresh()
    },
    goNext(){
      if(this.current_index>=(this.list.length-1)){
        Toast('已经是最后一支队伍了')
        return 
      }
      this.current_index++
      this.onRefresh()
    },
 
    // 键盘输入
    onKey(value) {
      /**
       * 1. 不能有两个小数点
       * 2. 小数不能为 5
       * 3. 值需要是1-100 以内的值
       */
      let score = this.formData.score+''
      // 打分完成 禁止输入
      if (this.scoreCurrent && !this.scoreStatus) return


      console.log(value, score, score.length)

      if (value == 'delete' && score.length > 0) {
        // 删除
        score = score.substring(0, score.length - 1);
        this.formData.score = score
        return;
      }

      if (value === 'delete') return
      if ((!score || score.indexOf('.') > -1) && value === '.') {
        return
      }
      if (!score && value === 0) return

      if (score.indexOf('.') > -1 && value != 5) {
        score = score.substring(0, score.length - 1);
        this.formData.score = score
        Toast('小数值只能为5');
        return
      }

      score = score + value

      if (score > 100) {
        Toast('分值不能大于100哦');
        return
      }

      // 缓存score值
      localStorage.setItem('_score', score)


      this.formData.score = score
    },
       
    onSelect(item,index){
      this.current_index = index
      this.listShow = false
      this.onRefresh()
    },
    onCopy(){
      Toast('复制成功，您可以在电脑端输入浏览器地址栏打开')
    },

    onSubmit() {
      let that = this
      if (!that.formData.score) {
        Toast('请输入分值')
        return
      }
      that.formData.content = that.commentResult.map(citem =>{
        return citem.name
      }).join("\n");
      Dialog.confirm({
        title: '评分',
        message: '确认评分吗',
      })
          .then(() => {
            // on confirm
            that.$api.post('/api/dshequscore/scoreSave', that.formData, (res) => {
              // 通知服务端
              // 提交分数成功
              let data = {
                'id': that.start_id
              }

              localStorage.removeItem('_score')
              localStorage.removeItem('_content')
              // let val = that.formatSocketInfo('score_submit', localStorage.getItem('_id_num'), data)
              // that.socket.send(val);

              that.scoreStatus = ''
              that.scoreCurrent = that.formData.score
              that.commentContent = that.formData.content
              Toast.success('打分成功')
              that.onRefresh()
            }, (res) => {
              if (res.code == 401 || res.code == 402) {
                if (window.isApp()) {
                  rbLink({
                    name: 'login', 'query': {}
                  }, 'replace');
                  return false;
                }
                that.loginShow = true
              } else {
                Toast(res.msg)
              }
            }, 2)

            that.saveLoading = true
          })
          .catch(() => {
            // on cancel
          });

    }, 
  }
}
</script>



// WEBPACK FOOTER //
// ShequScore.vue?9c2b78da